
import { logger } from "@/utils/logger";
import { Options, Vue } from "vue-class-component";
import { Emit } from "vue-property-decorator";
import store from "@/store";
import i18n from "@/i18n";
import Notification from "@/components/communication/Notification.vue";
import LanguageProfil from "@/components/user-preference/LanguageProfile.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { Message } from "@/types";
import { settings } from "@/settings";
import { base64StringToFile, getTokenStorage, UON } from "@/utils";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import router from "@/router";
import { getBase64 } from "@/commons/gathering-process-order";
import { api } from "@/auth/api";
import QUploader from 'quasar/src/components/uploader/QUploader.js';import Notify from 'quasar/src/plugins/Notify.js';;
import { fetchSupersetConfiguration } from "@/store/services/superset/supersetService";
import {useGeneralInfoStore} from "@/components/task/generalInfo/taskGeneralInfoStore";
import { useRoute } from 'vue-router';
import { getThemeMode, toggleThemeMode, type ThemeMode } from "@/utils/themeMode";
import { NOTIFICATION_RETENTION_DAYS } from "@/utils/notificationDate";

const api_query_url = settings.api_query_url;
const systemUid = `odm-contactmechanism`;
const baseUrlGenerated = `${settings.api_url}/${systemUid}/api/1/event/${systemUid}`;
const generalInfoStore = useGeneralInfoStore();
@Options({
  name: "app-header",
  components: {
    Notification,
    LanguageProfil,
  },
  computed: {
    ...mapState("notificationModule", ["notifications"]),
    ...mapGetters("notificationModule", ["getData", "getDataSize"]),
    ...mapState("messagingModule", ["recipients"]),
    ...mapGetters("messagingModule", ["getRecipients"]),
  },
  methods: {
    ...mapActions("notificationModule", ["fetchData"]),
    ...mapActions("messagingModule", ["fetchRecipients"]),

    onClickNotif() {
      /**
       * Gets the list of Recipients options for a selection.
       @returns {Array} List of Recipients options for selection.
       */
      this.fetchRecipients();
    },
  },
  watch: {
    "$store.state.appSelectedLogoFile": {
      handler(newvalue) {
        logger.debug("newval", newvalue)
      },
      deep: true, // Watch nested properties
    },
    "$store.state.authModule.selectedAvatar"(newValue) {
      this.loadPreview()
    }

  },

})
export default class Header extends Vue {
  message!: Message;
  filterInput = "";
  notificationSortType: "date" | "importance" | "unread" = "date";
  seeAllBtn = false;
  unreadBtn = false;
  readBtn = false;
  preview: any = null;
  getData!: Message[];
  getAllUser!: () => void;
  fetchData!: (payload: any) => void;
  fetchRecipients!: () => void;
  getDataSize!: number;
  showDetails = false;
  startAnalysisListenerCount = 0;
  backgroundLoginImage = require("@/assets/images/teamwill.png");
  themeMode: ThemeMode = getThemeMode();
  markAllAsReadLoading = false;
  notificationRetentionDays = NOTIFICATION_RETENTION_DAYS;

  onToggleTheme() {
    this.themeMode = toggleThemeMode();
  }

  show() {
    this.showDetails = true;
  }

  get userPreviewImg() {
    return store.state.authModule?.selectedAvatar;
  }
  toDataURL(image: any) {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.addEventListener("load", () => resolve(reader.result), false);

      reader.readAsDataURL(image);
    });
  }
  async loadPreview() {

    try {
      if (this.userPreviewImg instanceof Blob) {
        this.preview = await this.toDataURL(this.userPreviewImg);
      //  logger.debug("Loading preview image...", this.preview);
      }
    } catch (error) {
      logger.error("Error loading preview image:", error);
    }
  }
  get getAppLogoFile() {
    return store.state.appLogoBase64
  }

  get listener() {
    return async () => {
      await fetchEventSource(`${baseUrlGenerated}/listener/`, {
        headers: {
          Authorization: `Bearer ${getTokenStorage()}`,
        },
        async onopen(res) {
          if (res.ok && res.status === 200) {
            logger.warn("Connection made ", res);
          } else if (res.status >= 400 && res.status < 500 && res.status !== 429) {
            logger.warn("Client side error ", res);
          }
        },
        onmessage: (event) => {
        //  logger.debug('message',event)
          if (event.data !== "*|*\n\n") {
            this.fetchData({ ressourceUid: event.data.trim() });
          }
          if(this.$route.fullPath.includes('/task/detail')) {
            const task = store.state.taskModule.selectedTask;
            const origin = "listener";
            const taskDefinition = generalInfoStore.task.taskDefinition;
            if (generalInfoStore.task.taskDefinition === 'STEP_PRINT_DOCUMENT' && store.state.taskModule.selectedTask.variables.offerStatus === 'ELECSIGNATURE_INPROGRESS'){
              const offerId = store.state.taskModule.selectedTask.variables.offerId
              store.dispatch('taskModule/checkOfferStatus', {offerId});
            } else if (generalInfoStore.task.taskDefinition === 'STEP_START_ANALYSIS'){
              this.startAnalysisListenerCount += 1;
              if (this.startAnalysisListenerCount % 10 === 0) {
                store.dispatch('taskModule/getSelectedTask', {task, origin, taskDefinition});
              }
            }
          }
          return true;
        },
        onclose() {
          logger.warn("Connection closed by the server");
        },
        onerror(err) {
          logger.warn("There was an error from server", err);
        },
      });
    };
  }

  async created() {
    this.listener();
    this.loadData();
  //  logger.warn(this.getData);
    /**
     * Gets the list of Recipients options for a selection.
     @returns {Array} List of Recipients options for selection.
     */
    this.fetchRecipients();
    this.getDataSize;
    //const appLogoConfig = await fetchSupersetConfiguration('THEME_LOGO_APPLICATION');
   //  if (appLogoConfig && appLogoConfig.length > 0) {
   //   this.fetchAppLogo(appLogoConfig)
   // }
    this.loadPreview();
  }
  async fetchAppLogo(appLogoConfig: any) {
    const systemUid = UON.SystemUid.odmFileManagement;
    try {
      const paramValue = appLogoConfig && appLogoConfig[0] && appLogoConfig[0].param_value ? appLogoConfig[0].param_value : null;
      const response = await api().get(`/${systemUid}/api/1/${systemUid}/file/${paramValue}/`, { responseType: 'json' });

      if (response && response.data && response.data.content) {
        store.state.appLogoBase64 = response.data.content
      }

    } catch (error) {
      logger.error("Error fetching app logo:", error);
    }
  }
  loadData() {
    this.fetchData(null);
  }

  confirmLogout = false;

  get daaqModel() {
    const userDaaq = store?.state?.authModule?.daaqResourceUid;
    if (userDaaq) {
      return {
        value: userDaaq,
        label: store?.state?.authModule?.daaqLabel,
      };
    }
    return undefined;
  }

  onSelectDAAQ(event: any) {
    store.dispatch("authModule/selectDAAQ", {
      daaq: event.config.daaq,
      daaqResourceUid: event.config.resourceUid,
      daaqLabel: event.config.label,
    });
  }
  formatAuthority(group: any) {
    return i18n.global.t("middleOffice.decision.profil." + group.resourceUid)
  }

  @Emit("collapseToggle")
  collapseToggle() { }

  logout() {
    this.confirmLogout = true;
  }
  UserPreference() {
    router.push("/profile");
  }
  // get daaqList() {
  //   return this.user?.daaqList || [];
  // }

  get userGroups() {
    return store.state?.authModule?.groups
  }
  get daaqList(): Array<{ authority: string, ressourceUid: string }> {
    return this.user?.authorities || [];
  }
  get firstName() {
    return this.user?.firstName;
  }

  get lastName() {
    return this.user?.lastName;
  }

  get user() {
    return store?.state?.authModule?.user;
  }
  
  get initials() {
    const firstInitial = this.user?.firstName?.trim()?.charAt(0) || '';
    const lastInitial = this.user?.lastName?.trim()?.charAt(0) || '';
    const initials = `${firstInitial}${lastInitial}`.toUpperCase();

    return initials || '--'; 
  }

  get displayName() {
    const firstName = this.user?.firstName?.trim() || '';
    const lastName = this.user?.lastName?.trim() || '';
    const fullName = `${firstName} ${lastName}`.trim();
    return fullName || this.user?.username || '';
  }

  get primaryUserRole() {
    const groups = (this.userGroups ?? []) as Array<{ group?: { resourceUid?: string } }>;
    const firstGroup = groups[0]?.group;
    if (firstGroup) {
      return this.formatAuthority(firstGroup);
    }
    return '';
  }

  get cancelButtonLabel() {
    return i18n.global.t("main.confirmationDialog.cancelButton");
  }

  get confirmationButtonLabel() {
    return i18n.global.t("main.confirmationDialog.confirmationButton");
  }

  /**
   * Getter function to retrieve the value of msgStatusTabs.
   * @returns {Array} array of msgStatusTabs from the store's notificationModule state.
   */
  get msgStatusTabs() {
    return store?.state?.notificationModule?.msgStatusTabs;
  }

  /**
   * Getter function to retrieve the value of selectedstatusTab.
   * @returns {string} The value of msgSelectedStatusTab from the store's notificationModule state.
   */
  get selectedstatusTab() {
    return store?.state?.notificationModule?.msgSelectedStatusTab;
  }

  /**
   * Getter function to retrieve filtered data based on filterInput and selectedstatusTab.
   * @returns {Array<Notification>} Filtered data based on the filterInput value and selectedstatusTab from the store's notificationModule state.
   */
  get filteredData() {
    const data = [...(this.getData || [])];
    const searchTerm = this.filterInput?.trim() || "";

    const filtered = data.filter((item: any) => {
      const matchesStatus =
        this.selectedstatusTab === "ALL" ||
        item.status?.resourceUid === this.selectedstatusTab;

      return matchesStatus && this.matchesNotificationSearch(item, searchTerm);
    });

    return filtered.sort((a: any, b: any) => this.compareNotifications(a, b));
  }

  matchesNotificationSearch(item: any, searchTerm: string): boolean {
    if (!searchTerm) {
      return true;
    }

    const normalizedSearch = searchTerm.toLowerCase();
    const subject = item.subject?.resourceUid?.toLowerCase() || "";
    const sender = item.sender?.toLowerCase() || "";
    const body = item.body?.toLowerCase() || "";
    const reference = item.reference?.toLowerCase() || "";
    const entityReference =
      item.metadata
        ?.find((meta: any) => meta.key === "Entity_Reference")
        ?.value?.toLowerCase() || "";
    const context =
      item.metadata
        ?.find((meta: any) => meta.key === "Context")
        ?.value?.toLowerCase() || "";

    return (
      subject.includes(normalizedSearch) ||
      sender.includes(normalizedSearch) ||
      body.includes(normalizedSearch) ||
      reference.includes(normalizedSearch) ||
      entityReference.includes(normalizedSearch) ||
      context.includes(normalizedSearch)
    );
  }

  compareNotifications(a: any, b: any): number {
    switch (this.notificationSortType) {
      case "unread":
        if (a.status?.resourceUid !== b.status?.resourceUid) {
          return a.status?.resourceUid === "NEW" ? -1 : 1;
        }
        break;
      case "importance":
        return (b.priority || 0) - (a.priority || 0);
      default:
        break;
    }

    return (
      new Date(b.communicationDate).getTime() -
      new Date(a.communicationDate).getTime()
    );
  }

  getNotificationStoreIndex(notification: any): number {
    return (this.getData || []).findIndex(
      (item: any) => item.resourceUid === notification.resourceUid
    );
  }

  sortNotificationList(type?: string) {
    this.notificationSortType = (type as "date" | "importance" | "unread") || "date";
  }

  onClickLogoutButton() {
    this.$store.dispatch("authModule/signOut");
  }

  /**
   * Handles the event when the status tab is changed and updates the selected status tab.
   * @param {string} selectedStatus - The selected status value to update.
   */
  onStatusTabChanged(selectedStatus: string) {
    this.$store.dispatch("notificationModule/updateSelectedStatusTab", selectedStatus);
  }

  async markAllNotificationsAsRead() {
    if (this.markAllAsReadLoading || !this.getDataSize) {
      return;
    }

    this.markAllAsReadLoading = true;
    try {
      await this.$store.dispatch("notificationModule/markAllAsRead");
      Notify.create({
        timeout: 2500,
        message: i18n.global.t("communication.comNotification.markAllAsReadSuccess"),
        color: "positive",
        icon: "done_all",
      });
    } catch {
      await this.$store.dispatch("notificationModule/fetchData", null);
      Notify.create({
        timeout: 5000,
        actions: [{ icon: "close", color: "white" }],
        message: i18n.global.t("communication.comNotification.markAllAsReadError"),
        color: "negative",
      });
    } finally {
      this.markAllAsReadLoading = false;
    }
  }
}
